import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { AlertTriangle } from 'react-feather';

const PageNotFound = () => {
  const isEmbedded = window.self !== window.top;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f9fa'
      }}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md="6">
            <AlertTriangle size={64} className="mb-3 text-warning" />

            <h2 className="mb-2">Access Denied</h2>

            <p className="text-muted mb-4">
              {isEmbedded
                ? 'This page cannot be accessed without a valid authorization token.'
                : 'The page you are looking for does not exist.'}
            </p>

            {!isEmbedded && (
              <Button color="primary" onClick={() => (window.location.href = '/')}>
                Go to Home
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageNotFound;
